import { Component } from '@angular/core';
import { Settings } from './core/models/app.settings.model';
import { AppSettings } from './core/models/app.settings';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  public settings: Settings;
  constructor(private translate: TranslateService, public appSettings: AppSettings) {
    this.settings = this.appSettings.settings;
    const language = this.settings.language;
    this.translate.addLangs(['en', 'ar']);
    this.translate.setDefaultLang(language);
    this.translate.use(language);
  }
}
